// src/pages/sis/Enrollment.js
import React from "react";
import StudentForm from "./StudentForm";
import { addStudent, generateAvailableStudentId, getAllStudents } from "../../services/studentsService";

export default function Enrollment() {
  async function createStudent(record) {
    const list = getAllStudents();
    const norm = s => String(s || "").trim().toLowerCase();
    const sameByLRN = (a, b) => norm(a.lrn) && norm(a.lrn) === norm(b.lrn);
    const sameByNameBday = (a, b) =>
      norm(a.firstName) === norm(b.firstName) &&
      norm(a.lastName) === norm(b.lastName) &&
      norm(a.birthdate) === norm(b.birthdate);
    const dup = (list || []).find(s => sameByLRN(s, record) || sameByNameBday(s, record));
    if (dup) {
      alert(`Existing student found (${dup.id}). Enrollment was not saved to avoid overwriting. Please open Students and edit that record instead.`);
      return;
    }
    try {
      const typedId = String(record?.id || "").trim();
      const finalId = typedId || await generateAvailableStudentId(record.campus);
      const finalRec = { ...record, id: finalId };
      await addStudent(finalRec);
      alert("Enrollment saved successfully.");
    } catch (err) {
      const msg = err?.message || "Unknown error";
      const code = err?.code ? ` (${err.code})` : "";
      alert(`Failed to save enrollment: ${msg}${code}`);
    }
  }

  return (
    <div className="container mt-4">
      <h3 className="mb-4">Student Enrollment Form</h3>
      <StudentForm
        initial={{ campus: "gapan" }}
        onSubmit={createStudent}
      />
    </div>
  );
}
